(() => {
  if (window.jdDiagnosticBridgeLoaderReady) return;
  window.jdDiagnosticBridgeLoaderReady = true;

  const current = document.currentScript?.src || '';
  if (!current) return;

  const assetUrl = (filename) => {
    const url = new URL(current, window.location.href);
    url.pathname = url.pathname.replace(/\/[^/]+$/, `/${filename}`);
    url.search = '';
    url.hash = '';
    return url.toString();
  };

  const load = (filename) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.async = false;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`No se pudo cargar ${filename}`));
    document.head.appendChild(script);
  });

  load('jd-diagnostic-lead-bridge-core.js')
    .then(() => load('jd-diagnostic-quick-replies.js'))
    .then(() => load('jd-diagnostic-calendar.js'))
    .catch((error) => console.error('[JUANDIAZ.MX diagnostic]', error));
})();
